import { render, staticRenderFns } from "./createdCuentasCruzadas.vue?vue&type=template&id=1df45fae&scoped=true"
import script from "./createdCuentasCruzadas.vue?vue&type=script&lang=js"
export * from "./createdCuentasCruzadas.vue?vue&type=script&lang=js"
import style0 from "./createdCuentasCruzadas.vue?vue&type=style&index=0&id=1df45fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df45fae",
  null
  
)

export default component.exports